import React from 'react';

interface SidebarProps {
  currentView: string;
  onViewChange: (view: string) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ currentView, onViewChange }) => {
  const navigation = [
    {
      name: 'Dashboard',
      id: 'dashboard',
      icon: '📊',
      description: 'Overview and statistics'
    },
    {
      name: 'Leads',
      id: 'leads',
      icon: '👥',
      description: 'Manage conversations and leads'
    },
    {
      name: 'Analytics',
      id: 'analytics',
      icon: '📈',
      description: 'Conversation insights and drop-off analysis'
    },
    {
      name: 'Knowledge Base',
      id: 'knowledge',
      icon: '📚',
      description: 'Upload and manage documents'
    },
    {
      name: 'Segments',
      id: 'segments',
      icon: '🎯',
      description: 'Lead segmentation and targeting'
    },
    {
      name: 'Resources',
      id: 'resources',
      icon: '📄',
      description: 'Lead magnets and downloads'
    },
    {
      name: 'Campaigns',
      id: 'campaigns',
      icon: '📧',
      description: 'AI-powered email campaigns'
    },
    {
      name: 'Templates',
      id: 'templates',
      icon: '🎨',
      description: 'Email template management'
    },
    {
      name: 'Widget Settings',
      id: 'widget',
      icon: '⚙️',
      description: 'Customize chat widget'
    },
    {
      name: 'Email Notifications',
      id: 'email-notifications',
      icon: '✉️',
      description: 'Form submission alerts'
    }
  ];

  return (
    <div className="bg-white shadow-sm w-64 min-h-screen border-r border-gray-200">
      <div className="p-6">
        <h2 className="text-lg font-semibold text-gray-900">Navigation</h2>
      </div>
      
      <nav className="mt-2">
        {navigation.map((item) => (
          <button
            key={item.id}
            onClick={() => onViewChange(item.id)}
            className={`w-full text-left px-6 py-3 text-sm font-medium transition-colors ${
              currentView === item.id
                ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-500'
                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
            }`}
          >
            <div className="flex items-center">
              <span className="text-lg mr-3">{item.icon}</span>
              <div>
                <div className="font-medium">{item.name}</div>
                <div className="text-xs text-gray-500">{item.description}</div>
              </div>
            </div>
          </button>
        ))}
      </nav>

      <div className="absolute bottom-0 left-0 right-0 p-6 border-t border-gray-200">
        <div className="text-xs text-gray-500">
          <div className="font-medium">Widget Demo</div>
          <a 
            href="http://localhost:8080" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-700"
          >
            View Demo →
          </a>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;